import { Link } from "react-router-dom";
import { Phone, MapPin, Clock } from "lucide-react";
import { LogoMark } from "./Logo";
import { WhatsAppIcon } from "./WhatsAppButton";
import {
  NAV_LINKS,
  SERVICES,
  SERVICES_PATH,
  PHONE_DISPLAY,
  PHONE_TEL,
  ADDRESS,
  HOURS,
  waLink,
  MAPS_LINK,
} from "../data/siteData";

export const Footer = () => (
  <footer className="relative border-t border-amber-500/10 bg-[#080809]" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-6 pt-20 lg:px-10">
      <div className="grid gap-12 pb-16 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-3">
            <LogoMark className="h-10 w-10" />
            <div className="leading-none">
              <p className="font-display text-xl font-medium tracking-[0.28em] text-amber-100">BELONG</p>
              <p className="mt-1 font-mono-alt text-[9px] uppercase tracking-[0.4em] text-amber-500/80">
                Salon & Spa
              </p>
            </div>
          </div>
          <p className="mt-6 max-w-xs text-sm font-light leading-relaxed text-stone-400">
            A sanctuary in Suchitra devoted to a single art — the healing of the body through touch.
          </p>
        </div>

        <div>
          <p className="font-mono-alt text-[10px] uppercase tracking-[0.3em] text-amber-500/80">Explore</p>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.path}>
                <Link
                  to={l.path}
                  data-testid={`footer-${l.testid}`}
                  className="text-sm font-light text-stone-400 transition-colors hover:text-amber-200"
                >
                  {l.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-mono-alt text-[10px] uppercase tracking-[0.3em] text-amber-500/80">Services</p>
          <ul className="mt-5 space-y-3">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link
                  to={`${SERVICES_PATH}/${s.slug}`}
                  data-testid={`footer-service-link-${s.slug}`}
                  className="text-sm font-light text-stone-400 transition-colors hover:text-amber-200"
                >
                  {s.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-mono-alt text-[10px] uppercase tracking-[0.3em] text-amber-500/80">Visit Us</p>
          <ul className="mt-5 space-y-4 text-sm font-light text-stone-400">
            <li>
              <a href={PHONE_TEL} data-testid="footer-phone-link" className="flex items-center gap-3 transition-colors hover:text-amber-200">
                <Phone className="h-4 w-4 shrink-0 text-amber-500/70" /> {PHONE_DISPLAY}
              </a>
            </li>
            <li>
              <a
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-btn"
                className="flex items-center gap-3 transition-colors hover:text-amber-200"
              >
                <WhatsAppIcon className="h-4 w-4 shrink-0 text-[#25D366]" /> WhatsApp Booking
              </a>
            </li>
            <li>
              <a
                href={MAPS_LINK}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-address-link"
                className="flex items-start gap-3 transition-colors hover:text-amber-200"
              >
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-amber-500/70" />
                <span className="leading-relaxed">{ADDRESS}</span>
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Clock className="h-4 w-4 shrink-0 text-amber-500/70" /> {HOURS}
            </li>
          </ul>
        </div>
      </div>

      <div className="select-none overflow-hidden" aria-hidden="true">
        <p className="text-outline whitespace-nowrap text-center font-display text-[22vw] font-semibold leading-[0.85] tracking-tight lg:text-[17rem]">
          BELONG
        </p>
      </div>

      <div className="flex flex-col items-center justify-between gap-3 border-t border-white/5 py-7 md:flex-row">
        <p className="font-mono-alt text-[10px] uppercase tracking-[0.25em] text-stone-500">
          © 2026 Belong Salon & Spa · Suchitra, Hyderabad
        </p>
        <p className="font-mono-alt text-[10px] uppercase tracking-[0.25em] text-stone-600">
          Body Massage & Spa Services Only
        </p>
      </div>
    </div>
  </footer>
);
